export default __webpack_public_path__ + "static/media/start.3ff7c147.jpg";